module.exports = __webpack_public_path__ + "img/type3.89d355aa.png";